module.exports = __webpack_public_path__ + "98403330862168e6f95eeb1143dd7bca.svg";